// Map of share platforms to the URL parameter that carries the page address.
// Facebook and WhatsApp use different names (u / text) than LinkedIn and X (url).
const URL_PARAM_BY_PLATFORM: Record<string, string> = {
  facebook: 'u',
  x: 'url',
  linkedin: 'url',
  whatsapp: 'text',
  email: 'body',
};

export function initArticleShare(doc: Document = document): void {
  const sections = doc.querySelectorAll<HTMLElement>('[data-fc-component="article-share"]');
  if (sections.length === 0) return;

  const pageUrl = window.location.href;

  sections.forEach((section) => {
    section.querySelectorAll<HTMLAnchorElement>('a[data-article-share]').forEach((a) => {
      const platform = a.dataset.articleShare ?? '';
      const param = URL_PARAM_BY_PLATFORM[platform];
      if (!param) return;
      try {
        const u = new URL(a.href);
        u.searchParams.set(param, pageUrl);
        a.href = u.toString();
      } catch {
        /* malformed href — leave SSR link as-is */
      }
    });
  });
}
